export const AI_SELECT_SCREEN = "AI_SELECT_SCREEN";
export const AISelectScreen = (payload) => ({
  type: AI_SELECT_SCREEN,
  payload,
});

export const AI_SET_SWOT_DATA = "AI_SET_SWOT_DATA";
export const AISetSWOTData = (payload) => ({
  type: AI_SET_SWOT_DATA,
  payload,
});

export const AI_SET_TREND_DATA = "AI_SET_TREND_DATA";
export const AISetTrendData = (payload) => ({
  type: AI_SET_TREND_DATA,
  payload,
});

export const AI_GET_DATA_BY_OPTION = "AI_GET_DATA_BY_OPTION";
export const AIGetDataByOption = (payload) => ({
  type: AI_GET_DATA_BY_OPTION,
  payload,
});

export const AI_GET_DATA_BY_OPTION_SUCCESS = "AI_GET_DATA_BY_OPTION_SUCCESS";
export const AIGetDataByOptionSuccess = (payload) => ({
  type: AI_GET_DATA_BY_OPTION_SUCCESS,
  payload,
});
